import { tns } from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.text-image-slider').forEach(async (element) => {
    // eslint-disable-next-line no-unused-vars
    const slider = tns({
      container: element.querySelector('.text-image-slider__wrapper'),
      items: 1,
      slideBy: 'page',
      autoplay: false,
      controlsPosition: 'bottom',
      navPosition: 'bottom',
      autoplayButtonOutput: false,
      controlsContainer: element.querySelector('.text-image-slider__controls'),
    });

    // Function to update tabindex dynamically
    const updateTabIndex = () => {
      document.querySelectorAll('.teaser-logo-slider__element').forEach((el) => {
        if (el.classList.contains('tns-slide-active')) {
          //el.setAttribute('tabindex', '0');
          const link = el.querySelector('.button');
          if (link) {
            link.setAttribute('tabindex', '0');
          }
        } else {
          //el.setAttribute('tabindex', '-1');
          const link = el.querySelector('.button');
          if (link) {
            link.setAttribute('tabindex', '-1');
          }
        }
      });
      document.querySelectorAll('.tns-nav .tns-nav-active').forEach((navItem) => {
        navItem.setAttribute('tabindex', '-1');
      });
    };

    // Call the function initially and on index change
    updateTabIndex();
    slider.events.on('indexChanged', updateTabIndex);
  });
});
